import * as React from 'react';

import { styled } from "@mui/material/styles";

import { ChevronLeft, ChevronRight } from '@mui/icons-material';


import NFTree from './NFTree';

function shuffleArray(array) {
    for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
    return array
}

const SliderContainer = styled("div")(() => ({
    width: "100%",
    height: "630px",
    position: "relative",
    display: "flex",
    alignItems: "center"
  }));

  const Slider = styled("div")(() => ({
    width: "100%",
    height: "100%",
    whiteSpace: "nowrap",
    overflowX: "scroll",
    scrollbarWidth: "none",
    scrollBehavior: "smooth",
  }));

class NFTreesGallery extends React.Component<any, any> {

    slideLeft() {
        var slider = document.getElementById('slider');
        if (slider != null){
            console.log("left");
            slider.scrollLeft = slider.scrollLeft - 500;
        }
    }

    slideRight() {
        var slider = document.getElementById('slider');
        if (slider != null) {
            console.log("right");
            slider.scrollLeft = slider.scrollLeft + 500;
        }
    }

    render() {
        if (this.props.isLoaded) {
            return (
                <SliderContainer>
                    <ChevronLeft onClick={this.slideLeft} style={{fontSize:40, marginLeft:-20}} />
                    <Slider id="slider">
                        {shuffleArray(this.props.nftrees).map((n, index) => {
                            return (
                                <NFTree theme metadata={n.metadata} uri={n.uri} key={index}/>
                            )
                        })}
                    </Slider>
                    <ChevronRight onClick={this.slideRight} style={{fontSize:40, marginRight:-20}} />
                </SliderContainer >
            )
        }
    }
}

export default NFTreesGallery